import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DispatchBoardComponent } from './components/dispatch-board/dispatch-board.component';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';

const routes: Routes = [

    // { path: '', redirectTo: 'dispatch', pathMatch: 'full'},
    {
      path: 'embed_dispatch_board',
      canActivate: [AuthGuard],
      canActivateChild: [AuthGuard],
      component: LayoutComponent,
      pathMatch: 'full',
      resolve: {
          initialData: InitialDataResolver,
      },
      data: {
        layout: 'empty',
        app: 'dispatch'
      },
      children: [
          { path: '',
          component: DispatchBoardComponent}
      ]
    },
    // Admin routes
    {
        path: 'dispatch_board',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: InitialDataResolver,
        },
        children: [
          { path: '', component: DispatchBoardComponent }
        ],
        data: { 'module': 'DISPATCH_BOARD', 'page': 'dispatch_board' }
    },
    { path: 'dispatchBoard', redirectTo: 'dispatch_board' },
    { path: '', redirectTo: 'dashboard', pathMatch: 'full' },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
